<template>
    <div id="header" ref="header">
        <div class="header">
            <img
                data-path="index"
                @click="path"
                src="https://oss.eventnet.cn/H5/mi/logo.png?v=1043"
                alt=""
                class="pc_logo"
            />
            <div class="nav_list">
                <p
                    v-for="(item, index) in $t('menu')"
                    :class="{ menu_active: index == current }"
                    v-if="index !== 'index'"
                    :key="'ch' + index"
                >
                    <span
                        v-if="index !== 'index'"
                        @click="path"
                        :data-path="index"
                        >{{ item }}</span
                    >
                </p>
            </div>
            <div class="language">
                <span @click="changeLang" :class="langs == 'zh' ? 'active' : ''" data-lang="zh"
                    >中</span
                >
                |
                <span @click="changeLang" :class="langs == 'en' ? 'active' : ''" data-lang="en"
                    >EN</span
                >
            </div>
            <div
                class="header_login"
                v-if="signUped"
                data-path="login"
                @click="path"
            >
                {{ $t("login").title }}
            </div>
            <div
                class="header_login"
                v-else
                style="
                    background: transparent;
                    background: transparent;
                    border: 1px solid #ff6900;
                    height: 35px;
                    line-height: 1;
                    border-radius: 5px;
                    font-size: 15px;
                "
                @click="signOut"
            >
                {{ $t("login").signOut }}
            </div>
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "",
    inject: ["reload"],
    data() {
        return {
            isActive: true,
            menu_active: 0,
            langs: "",
            toastShow: false,
            toastText: "",
            current: "",
            signUped: false,
            token: localStorage.getItem("token"),
        };
    },
    watch: {
        token() {
            this.token = localStorage.getItem("token");
        },
    },
    created() {
        let lang = localStorage.getItem("lang"),
            data = new FormData(),
            that = this;
        that.$i18n.locale = lang;
        that.langs = lang;
        let url = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
            window.location.href.length
        );
        that.current = url;
        if (that.token == "" || that.token == null) {
            that.signUped = true;
        } else {
            that.signUped = false;
        }
    },
    methods: {
        changeLang(e) {
            let lang = e.target.dataset.lang,
                that = this;
            this.langs = that.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            that.isActive = lang == "zh" ? true : false;
            document.title = this.$t("share.title");
        },
        path(e) {
            let that = this,
                path = e.target.dataset.path;
            that.ISlodin();
            if (path == "personal") {
                that.token = localStorage.getItem("token");
                console.log(that.token);
                if (that.token == "" || that.token == null) {
                    that.toast(that.$t("signUp").login_tips);
                    return;
                } else {
                    that.$router.replace("/pc/" + path).catch(() => {});
                } // ||
            } else if (path == "live") {
                if (that.token == "" || that.token == null) {
                    that.toast(that.$t("signUp").login_tips);
                       setTimeout(() => {
                        that.$router.replace("/pc/login").catch(() => {});
                    }, 1500);
                    return;
                } else {
                    that.rq.post("/user/userinfo").then((res) => {
                        if (res.code == "1") {
                            localStorage.setItem(
                                "sign",
                                res.data.userinfo.audit_status
                            );
                            if (res.data.userinfo.audit_status == 1) {
                                that.toast(that.$t("personal").tips3);
                            } else if (res.data.userinfo.audit_status == 2) {
                                that.$router
                                    .replace("/pc/" + path)
                                    .catch(() => {});
                            } else if (res.data.userinfo.audit_status == 3) {
                                that.toast(that.$t("personal").tips2);
                            }
                        }
                    });
                }
            } else if(path == 'agenda'){
                if (that.token == "" || that.token == null){
                    that.toast(that.$t("signUp").login_tips);
                       setTimeout(() => {
                        that.$router.replace("/pc/login").catch(() => {});
                    }, 1500);
                }else{
                    that.$router.replace("/pc/" + path).catch(() => {});
                }
            }
            else{
                that.token = localStorage.getItem("token");
                that.$router.replace("/pc/" + path).catch(() => {});
            }
        },
        ISlodin() {},
        signOut() {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.$router.replace("/").catch(() => {});
        },
        toast(str) {
            let that = this;
            that.toastText = str;
            that.toastShow = true;
            setTimeout(function () {
                that.toastShow = false;
            }, 1600);
        },
    },
};
</script>
<style scoped>
i {
    font-style: normal;
}

img {
    display: block;
}

.textCenter {
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.sure {
    line-height: 71px;
}

.pc_menu {
    height: 100%;
    overflow-y: scroll;
}

#header {
    width: 100%;
    height: 70px;
    background: linear-gradient(
        90deg,
        #000000 0%,
        #2d1300 25%,
        #000000 73%,
        #2d1300 100%
    );
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
}

.banner {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto 0;
}

.header {
    width: 1200px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    position: relative;
    height: 100%;
}

.nav_list {
    display: flex;
    height: 100%;
    width: 869px;
    font-size: 16px;
    color: #fff;
    align-items: center;
    justify-content: flex-start;
    position: relative;
}

.nav_list p {
    height: 100%;
}

.nav_list p > span {
    display: block;
    align-items: center;
    height: 100%;
    cursor: pointer;
    font-size: 16px;
    /* min-width: 130px; */
    padding: 0 30px;
    text-align: center;
    line-height: 70px;
}

.nav_list p:hover span {
    position: relative;
}
/* .nav_list>p:first-child>span {
        width: 180px;
    }
    
    .nav_list>p:nth-child(2)>span {
        width: 100px;
    }
    
    .nav_list>p:nth-child(3)>span {
        width: 160px;
    }
    
    .nav_list>p:last-child>span {
        width: 300px;
    } */

.nav_list p:hover span::after {
    content: "";
    width: 29px;
    height: 3px;
    background: #ff6900;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -14.5px;
}

.nav_list p:nth-child(9):hover span::after {
    display: none;
}

.pc_logo {
    height: 70%;
    margin-right: 50px;
    margin-left: 13px;
    cursor: pointer;
}

.menu_active {
    position: relative;
    font-weight: bold;
    color: #ff6900;
}

.menu_active::after {
    content: "";
    width: 29px;
    height: 3px;
    background: #ff6900;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -14.5px;
}

.toast {
    /* font-size: 18px;
        height: 50px;
        line-height: 50px; */
    /* transform: scale(1) translateX(-50%) translateY(-50%)!important; */
}

.language {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #fff;
    font-size: 18px;
    line-height: 1;
}

.language span {
    padding: 0 8px;
}

.active {
    color: #ff6900;
}

.header_login {
    width: 87px;
    height: 70px;
    background: #ff6900;
    font-size: 18px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    margin-left: 20px;
    cursor: pointer;
    text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/headers.vue